/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-arrow-function-lifecycle */
/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Paper,
  Grid,
  Typography,
  TextField,
  Button,
  withStyles,
  Switch,
  Divider,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  Icon,
  ListItemSecondaryAction,
  ListItemIcon,
  Collapse,
} from '@material-ui/core';
import ExpandMore from '@material-ui/icons/ExpandMore';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import PropTypes from 'prop-types';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import DownChevron from '@material-ui/icons/ExpandMore';
import cloneDeep from 'lodash/cloneDeep';
import CreateAndEditWrapper from '../share/CreateAndEditWrapper';
import TaxActionDialog from './TaxActionDialog';
import IndeterminateCheckBox from '../../assets/img/indeterminate_check_box_black_24dp.svg';
import {
  resourceFormStyle,
  commonResourceStyle,
  v2DropdownStyles,
  displayResourceStyles,
} from '../../css/style';
import {
  resourceFields,
  validationErrorMessages,
  taxesTextConstants,
  taxActions,
  TAX_NAME_MAX_LENGTH,
} from '../../data/Constants';
import { createRequestData } from '../../utils/Functions';
import * as FieldValidation from '../crud/CreateAndEditResource/FieldValidation';

const styles = resourceFormStyle();
const commonStyles = commonResourceStyle();
const dropdownStyles = v2DropdownStyles();
const displayStyles = displayResourceStyles();
const IosSwitch = withStyles(styles.iosSwitchStyles)(Switch);

class CreateAndEditTax extends Component {
  constructor(props) {
    super(props);
    const { match } = this.props;
    const { resource } = match.params;
    const fields = resourceFields[resource];
    const taxDetail = {};
    fields.forEach((field) => {
      const { key } = field;
      const detail = {
        ...field,
        value: '',
        errorMessage: '',
        isValid: true,
      };
      taxDetail[key] = detail;
    });

    this.state = {
      taxDetail,
      isApply: false,
      showCategoriesProducts: false,
      selectedLocations: [],
      selectedAllLocationCategories: [],
      selectedAllLocationProducts: [],
      selectedLocationProducts: [],
      selectedLocationCategories: [],
      openLocation: [],
      openCategory: [],
      confirmDialogOpen: false,
      selectedAction: '',
    };
  }

  componentDidMount = async () => {
    await this.getTaxesResources();
    const {
      match,
      type,
      taxes,
    } = this.props;
    const { taxDetail } = this.state;
    const { resourceId } = match.params;
    const copyOfTaxDetail = cloneDeep(taxDetail);
    if (type === 'edit') {
      const taxToEdit = taxes.find(tax => tax.id === parseInt(resourceId));
      Object.values(copyOfTaxDetail).forEach((detail) => {
        const { key } = detail;
        detail.value = taxToEdit ? taxToEdit[key] : '';
      });
    }
    this.setState({
      taxDetail: copyOfTaxDetail,
    });
    await this.getMenuResources();
    if (type === 'edit') await this.getApplyResources(resourceId);
    this.selectFields();
  }

  selectFields = () => {
    const {
      taxedProducts,
      taxedCategories,
      taxedLocations,
      resources,
    } = this.props;
    const { categories, products } = resources;
    const productsArrangedByCategory = this.arrangeProductsByCategory(products, categories);
    let taxedCategoriesWithLocationScoping = taxedCategories.filter(cat => cat.location);
    let taxedProductsWithLocationScoping = taxedProducts.filter(prod => prod.location);
    const taxedCategoriesForAllLocation = taxedCategories.filter(cat => !cat.location);
    let taxedProductsForAllLocation = taxedProducts.filter(prod => !prod.location);
    for (let i = 0; i < taxedCategoriesWithLocationScoping.length; i++) {
      const productsOfCategory = productsArrangedByCategory[taxedCategoriesWithLocationScoping[i].id];
      const productsOfCategoryWithNeededKeyValues = productsOfCategory.map(prod => ({
        id: prod.id,
        name: prod.name,
        location: taxedCategoriesWithLocationScoping[i].location,
      }));
      taxedProductsWithLocationScoping = taxedProductsWithLocationScoping.concat(productsOfCategoryWithNeededKeyValues);
    }
    for (let index = 0; index < taxedLocations.length; index++) {
      const categoryMap = categories.map(cat => ({
        id: cat.id,
        name: cat.name,
        location: taxedLocations[index],
      }));
      taxedCategoriesWithLocationScoping = taxedCategoriesWithLocationScoping.concat(categoryMap);
      const productsMap = products.map(prod => ({
        id: prod.id,
        name: prod.name,
        location: taxedLocations[index],
      }));
      taxedProductsWithLocationScoping = taxedProductsWithLocationScoping.concat(productsMap);
    }
    for (let x = 0; x < taxedCategoriesForAllLocation.length; x++) {
      const productsOfCategory = productsArrangedByCategory[taxedCategoriesForAllLocation[x].id];
      const productsOfCategoryWithNeededKeyValues = productsOfCategory.map(prod => ({
        id: prod.id,
        name: prod.name,
      }));
      taxedProductsForAllLocation = taxedProductsForAllLocation.concat(productsOfCategoryWithNeededKeyValues);
    }

    this.setState({
      selectedLocations: taxedLocations,
      selectedLocationCategories: taxedCategoriesWithLocationScoping,
      selectedLocationProducts: taxedProductsWithLocationScoping,
      selectedAllLocationCategories: taxedCategoriesForAllLocation,
      selectedAllLocationProducts: taxedProductsForAllLocation,
    });
  }

  unselectFields = async () => {
    const {
      selectedAllLocationCategories,
      selectedAllLocationProducts,
      selectedLocationCategories,
      selectedLocationProducts,
      selectedLocations,
    } = this.state;
    const { resources } = this.props;
    const { categories, products } = resources;
    const productsArrangedByCategory = this.arrangeProductsByCategory(products, categories);
    const copyOfSelectedLocationCategories = cloneDeep(selectedLocationCategories);
    const copyOfSelectedLocationProducts = cloneDeep(selectedLocationProducts);
    const copyOfSelectedAllLocationProducts = cloneDeep(selectedAllLocationProducts);
    for (let index = 0; index < selectedLocations.length; index++) {
      copyOfSelectedLocationCategories.splice(
        0,
        copyOfSelectedLocationCategories.length,
        ...copyOfSelectedLocationCategories.filter(
          cat => cat.location.id !== selectedLocations[index].id,
        ),
      );
      copyOfSelectedLocationProducts.splice(
        0,
        copyOfSelectedLocationProducts.length,
        ...copyOfSelectedLocationProducts.filter(
          prod => prod.location.id !== selectedLocations[index].id,
        ),
      );
    }
    for (let i = 0; i < selectedAllLocationCategories.length; i++) {
      const productsOfCategory = productsArrangedByCategory[selectedAllLocationCategories[i].id];
      productsOfCategory.forEach((prod) => {
        copyOfSelectedAllLocationProducts.splice(
          0,
          copyOfSelectedAllLocationProducts.length,
          ...copyOfSelectedAllLocationProducts.filter(
            prod1 => prod1.id !== prod.id,
          ),
        );
      });
    }

    this.setState({
      selectedLocationCategories: copyOfSelectedLocationCategories,
      selectedLocationProducts: copyOfSelectedLocationProducts,
      selectedAllLocationProducts: copyOfSelectedAllLocationProducts,
    });
  }

  componentDidUpdate = async (prevProps) => {
    const {
      apiToken,
      match,
      type,
    } = this.props;
    const { resourceId } = match.params;
    if (prevProps.apiToken !== apiToken) {
      await this.getTaxesResources(true);
      await this.getMenuResources(true);
      if (type === 'edit') {
        await this.getApplyResources(resourceId, true);
      }
    }
  }

  getTaxesResources = async (fetchForce = false) => {
    const {
      actions, loading, apiToken,
    } = this.props;
    const { getTaxes } = actions;

    if (loading === false || fetchForce) {
      await getTaxes(apiToken);
    }
  }

  getMenuResources = async (fetchForce = false) => {
    const {
      actions, apiToken, loading, resources,
    } = this.props;
    const { locations, products, categories } = resources;
    if (!locations || loading === false || fetchForce) {
      await actions.getAllResources(apiToken, 'locations');
    }
    if (!products || loading === false || fetchForce) {
      await actions.getAllResources(apiToken, 'products');
    }
    if (!categories || loading === false || fetchForce) {
      await actions.getAllResources(apiToken, 'categories');
    }
  }

  getApplyResources = async (taxId, fetchForce = false) => {
    const {
      actions, loading, apiToken,
    } = this.props;
    const {
      getTaxedLocations,
      getTaxedProducts,
      getTaxedCategories,
    } = actions;
    if (loading === false || fetchForce) {
      await getTaxedLocations(apiToken, taxId);
      await getTaxedProducts(apiToken, taxId);
      await getTaxedCategories(apiToken, taxId);
    }
  }

  onSwitchChange = () => {
    this.setState(state => ({ showCategoriesProducts: !state.showCategoriesProducts }));
  }

  onCheckDropdown = (
    event,
    field,
    isAllLocation,
    location,
    category,
    product,
  ) => {
    const {
      selectedLocations,
      selectedLocationProducts,
      selectedLocationCategories,
      selectedAllLocationCategories,
      selectedAllLocationProducts,
    } = this.state;
    const { resources } = this.props;
    const { products, categories } = resources;
    switch (field) {
      case 'locationOnly':
        if (event.target.checked) {
          this.setState({
            selectedLocations: selectedLocations.concat({
              id: location.id,
              name: location.name,
            }),
          });
        } else {
          this.setState({
            selectedLocations: selectedLocations.filter(
              ({ id: id1 }) => location.id !== id1,
            ),
          });
        }
        break;
      case 'location': {
        let indexOfProduct;
        let indexOfCategory;
        if (isAllLocation) {
          const categoryMap = categories.map(cat => ({ id: cat.id, name: cat.name }));
          const productMap = products.map(prod => ({ id: prod.id, name: prod.name }));
          if (event.target.checked) {
            this.setState({
              selectedAllLocationCategories: categoryMap,
              selectedAllLocationProducts: productMap,
            });
          } else {
            this.setState({
              selectedAllLocationCategories: [],
              selectedAllLocationProducts: [],
            });
          }
        } else if (!isAllLocation) {
          const categoryMap = categories.map(cat => ({
            id: cat.id,
            name: cat.name,
            location: {
              id: location.id,
              name: location.name,
            },
          }));
          const productMap = products.map(prod => ({
            id: prod.id,
            name: prod.name,
            location: {
              id: location.id,
              name: location.name,
            },
          }));
          if (event.target.checked) {
            for (let index = 0; index < selectedLocationProducts.length; index++) {
              indexOfProduct = productMap.findIndex(
                (prod) => {
                  if (prod.id === selectedLocationProducts[index].id
                      && prod.location.id === selectedLocationProducts[index].location.id) {
                    return true;
                  }
                  return false;
                },
              );
              if (indexOfProduct > -1) {
                productMap.splice(indexOfProduct, 1);
              }
            }
            for (let index = 0; index < selectedLocationCategories.length; index++) {
              indexOfCategory = categoryMap.findIndex(
                (cat) => {
                  if (cat.id === selectedLocationCategories[index].id
                      && cat.location.id === selectedLocationCategories[index].location.id) {
                    return true;
                  }
                  return false;
                },
              );
              if (indexOfCategory > -1) {
                categoryMap.splice(indexOfCategory, 1);
              }
            }
            this.setState({
              selectedLocations: selectedLocations.concat({
                id: location.id,
                name: location.name,
              }),
              selectedLocationCategories: selectedLocationCategories.concat(categoryMap),
              selectedLocationProducts: selectedLocationProducts.concat(productMap),
            });
          } else {
            const copyOfSelectedLocationProducts = cloneDeep(selectedLocationProducts);
            const copyOfSelectedLocationCategories = cloneDeep(selectedLocationCategories);
            for (let i = 0; i < categoryMap.length; i++) {
              copyOfSelectedLocationCategories.splice(
                0,
                copyOfSelectedLocationCategories.length,
                ...copyOfSelectedLocationCategories.filter(
                  (cat) => {
                    if (cat.id !== categoryMap[i].id) {
                      return true;
                    }
                    if (cat.id === categoryMap[i].id && location.id !== cat.location.id) {
                      return true;
                    }
                    return false;
                  },
                ),
              );
            }
            for (let i = 0; i < productMap.length; i++) {
              copyOfSelectedLocationProducts.splice(
                0,
                copyOfSelectedLocationProducts.length,
                ...copyOfSelectedLocationProducts.filter(
                  (prod) => {
                    if (prod.id !== productMap[i].id) {
                      return true;
                    }
                    if (prod.id === productMap[i].id && location.id !== prod.location.id) {
                      return true;
                    }
                    return false;
                  },
                ),
              );
            }
            this.setState({
              selectedLocations: selectedLocations.filter(
                loc => location.id !== loc.id,
              ),
              selectedLocationCategories: copyOfSelectedLocationCategories || [],
              selectedLocationProducts: copyOfSelectedLocationProducts || [],
            });
          }
        }
        break;
      }
      case 'category':
        if (isAllLocation) {
          const productsOfCategory = category.map(prod => ({ id: prod.id, name: prod.name }));
          let indexOfProduct;
          if (category[0]) {
            if (event.target.checked) {
              for (let index = 0; index < selectedAllLocationProducts.length; index++) {
                indexOfProduct = productsOfCategory.findIndex(
                  prod => prod.id === selectedAllLocationProducts[index].id,
                );
                if (indexOfProduct > -1) {
                  productsOfCategory.splice(indexOfProduct, 1);
                }
              }
              this.setState({
                selectedAllLocationCategories: selectedAllLocationCategories.concat({
                  id: category[0].category.id,
                  name: category[0].category.name,
                }),
                selectedAllLocationProducts: selectedAllLocationProducts.concat(productsOfCategory),
              });
            } else {
              const copyOfSelectedAllLocationProducts = cloneDeep(selectedAllLocationProducts);
              for (let i = 0; i < productsOfCategory.length; i++) {
                copyOfSelectedAllLocationProducts.splice(
                  0,
                  copyOfSelectedAllLocationProducts.length,
                  ...copyOfSelectedAllLocationProducts.filter(
                    prod => prod.id !== productsOfCategory[i].id,
                  ),
                );
              }
              this.setState({
                selectedAllLocationCategories: selectedAllLocationCategories.filter(
                  ({ id: id1 }) => category[0].category.id !== id1,
                ),
                selectedAllLocationProducts: copyOfSelectedAllLocationProducts || [],
              });
            }
          }
        } else if (!isAllLocation) {
          const productsOfCategory = category.map(
            prod => ({
              id: prod.id,
              name: prod.name,
              location: {
                id: location.id,
                name: location.name,
              },
            }),
          );
          let indexOfProduct;
          if (category[0]) {
            if (event.target.checked) {
              for (let index = 0; index < selectedLocationProducts.length; index++) {
                indexOfProduct = productsOfCategory.findIndex(
                  (prod) => {
                    if (prod.id === selectedLocationProducts[index].id
                        && prod.location.id === selectedLocationProducts[index].location.id) {
                      return true;
                    }
                    return false;
                  },
                );
                if (indexOfProduct > -1) {
                  productsOfCategory.splice(indexOfProduct, 1);
                }
              }
              this.setState({
                selectedLocationCategories: selectedLocationCategories.concat({
                  id: category[0].category.id,
                  name: category[0].category.name,
                  location: {
                    id: location.id,
                    name: location.name,
                  },
                }),
                selectedLocationProducts: selectedLocationProducts.concat(productsOfCategory),
              });
            } else {
              const copyOfSelectedLocationProducts = cloneDeep(selectedLocationProducts);
              for (let i = 0; i < productsOfCategory.length; i++) {
                copyOfSelectedLocationProducts.splice(
                  0,
                  copyOfSelectedLocationProducts.length,
                  ...copyOfSelectedLocationProducts.filter(
                    (prod) => {
                      if (prod.id !== productsOfCategory[i].id) {
                        return true;
                      }
                      if (prod.id === productsOfCategory[i].id && location.id !== prod.location.id) {
                        return true;
                      }
                      return false;
                    },
                  ),
                );
              }
              this.setState({
                selectedLocationCategories: selectedLocationCategories.filter(
                  (cat) => {
                    if (cat.id !== category[0].category.id) {
                      return true;
                    }
                    if (cat.id === category[0].category.id && location.id !== cat.location.id) {
                      return true;
                    }
                    return false;
                  },
                ),
                selectedLocationProducts: copyOfSelectedLocationProducts || [],
              });
            }
          }
        }
        break;
      case 'product':
        if (isAllLocation) {
          if (event.target.checked) {
            this.setState({
              selectedAllLocationProducts: selectedAllLocationProducts.concat({
                id: product.id,
                name: product.name,
              }),
            });
          } else {
            this.setState({
              selectedAllLocationProducts: selectedAllLocationProducts.filter(
                ({ id: id1 }) => product.id !== id1,
              ),
            });
          }
        } else if (!isAllLocation) {
          if (event.target.checked) {
            this.setState({
              selectedLocationProducts: selectedLocationProducts.concat({
                id: product.id,
                name: product.name,
                location: {
                  id: location.id,
                  name: location.name,
                },
              }),
            });
          } else {
            this.setState({
              selectedLocationProducts: selectedLocationProducts.filter(
                (prod) => {
                  if (prod.id !== product.id) {
                    return true;
                  }
                  if (prod.id === product.id && location.id !== prod.location.id) {
                    return true;
                  }
                  return false;
                },
              ),
            });
          }
        }
        break;
      default:
        return 'ERROR';
    }
  }

  isChecked = (field, location, category, product) => {
    const { resources } = this.props;
    const { products, categories } = resources;
    const {
      selectedAllLocationCategories,
      selectedAllLocationProducts,
      selectedLocationCategories,
      selectedLocationProducts,
      selectedLocations,
    } = this.state;
    switch (field) {
      case 'locationOnly':
        if (!selectedLocations) {
          return false;
        }
        return selectedLocations.find(loc => loc.id === location.id);
      case 'allLocation':
        return selectedAllLocationCategories.length === categories.length
          && selectedAllLocationProducts.length === products.length;
      case 'location': {
        const copyOfSelectedLocationProducts = cloneDeep(selectedLocationProducts);
        const copyOfSelectedLocationCategories = cloneDeep(selectedLocationCategories);
        const locationCategories = copyOfSelectedLocationCategories.filter(
          cat => cat.location.id === location.id,
        );
        const locationProducts = copyOfSelectedLocationProducts.filter(
          prod => prod.location.id === location.id,
        );
        return locationCategories.length === categories.length
          && locationProducts.length === products.length
          && selectedLocations.find(loc => loc.id === location.id);
      }
      case 'locationCategory': {
        const productsOfCategory = category.map(
          prod => ({
            id: prod.id,
            name: prod.name,
            location: {
              id: location.id,
              name: location.name,
            },
          }),
        );
        if (selectedLocationCategories.length <= 0 || selectedLocationProducts.length <= 0) {
          return false;
        }
        if (category[0]) {
          return selectedLocationCategories.some(
            cat => cat.id === category[0].category.id && cat.location.id === location.id,
          )
          && productsOfCategory.every(prod => selectedLocationProducts.some(
            prod1 => prod1.id === prod.id && prod1.location.id === prod.location.id,
          ));
        }
        return false;
      }
      case 'allLocationCategory': {
        const productsOfCategory = category.map(prod => ({ id: prod.id, name: prod.name }));
        if (selectedAllLocationCategories.length <= 0 || selectedAllLocationProducts.length <= 0) {
          return false;
        }
        if (category[0]) {
          return selectedAllLocationCategories.some(cat => cat.id === category[0].category.id)
            && productsOfCategory.every(prod => selectedAllLocationProducts.some(
              prod1 => prod1.id === prod.id,
            ));
        }
        return false;
      }
      case 'locationProduct': {
        if (selectedLocationProducts.length <= 0) {
          return false;
        }
        return selectedLocationProducts.some(
          prod => prod.location.id === location.id && prod.id === product.id,
        );
      }
      case 'allLocationProduct': {
        if (!selectedAllLocationProducts) {
          return false;
        }
        return selectedAllLocationProducts.some(prod => prod.id === product.id);
      }
      default:
        return 'ERROR';
    }
  }

  isIndeterminate = (field, location, category) => {
    const {
      selectedAllLocationCategories,
      selectedAllLocationProducts,
      selectedLocationCategories,
      selectedLocationProducts,
    } = this.state;
    switch (field) {
      case 'allLocation':
        return selectedAllLocationCategories.length > 0
          || selectedAllLocationProducts.length > 0;
      case 'location':
        return selectedLocationCategories.some(cat => cat.location.id === location.id)
          || selectedLocationProducts.some(prod => prod.location.id === location.id);
      case 'allLocationCategory':
        for (let i = 0; i < category.length; i++) {
          if (selectedAllLocationProducts.some(prod => prod.id === category[i].id)) {
            return true;
          }
        }
        return false;
      case 'locationCategory':
        for (let i = 0; i < category.length; i++) {
          if (selectedLocationProducts.some(
            prod => prod.id === category[i].id && prod.location.id === location.id,
          )) {
            return true;
          }
        }
        return false;
      default:
        return 'ERROR';
    }
  }

  areFieldsValid = () => {
    const { taxDetail } = this.state;
    let areAllValid = true;
    const copyOfTaxDetail = cloneDeep(taxDetail);
    const { isRequiredError } = validationErrorMessages.field;
    Object.values(copyOfTaxDetail).forEach((detail) => {
      const { isRequired, value } = detail;
      if (isRequired && !value) {
        detail.isValid = false;
        detail.errorMessage = isRequiredError;
        areAllValid = false;
      } else if (!detail.isValid) {
        areAllValid = false;
      }
    });
    if (!areAllValid) {
      this.setState({
        taxDetail: copyOfTaxDetail,
      });
    }
    return areAllValid;
  }

  onApplyPage = () => {
    this.setState({
      isApply: true,
    });
  }

  applyTaxToLocCatProd = (resourceId) => {
    const {
      actions,
      history,
      apiToken,
      match,
    } = this.props;
    const { resource } = match.params;
    const { updateTax } = actions;
    const { selectedLocations } = this.state;
    const taxedProductsRequestData = this.state.selectedAllLocationProducts.concat(
      this.state.selectedLocationProducts,
    );
    const taxedCategoriesRequestData = this.state.selectedAllLocationCategories.concat(
      this.state.selectedLocationCategories,
    );
    updateTax(apiToken, selectedLocations, ...[resource, resourceId, 'locations']).then(async (res) => {
      if (res.error) return;
      updateTax(apiToken, taxedCategoriesRequestData, ...[resource, resourceId, 'products']).then(async (res) => {
        if (res.error) return;
        updateTax(apiToken, taxedProductsRequestData, ...[resource, resourceId, 'categories']).then(async (res) => {
          if (res.error) return;
          history.push(`/${resource}`);
        });
      });
    });
  }

  onClickApplyChanges = async () => {
    const {
      actions, history, apiToken, match, type,
    } = this.props;
    const {
      resource, resourceId,
    } = match.params;
    const {
      taxDetail,
      isApply,
      selectedLocations,
      showCategoriesProducts,
    } = this.state;
    const taxedLocationsPath = [resource, resourceId, 'locations'];
    await this.unselectFields();
    const requestData = createRequestData(taxDetail);
    const resourcePath = type === 'edit' ? [resource, resourceId] : [resource];
    if (!this.areFieldsValid()) {
      return;
    }
    const { updateTax, addTax } = actions;
    if (type === 'edit') {
      if (isApply) {
        if (!showCategoriesProducts) {
          updateTax(apiToken, selectedLocations, ...taxedLocationsPath).then(async (res) => {
            if (res.error) return;
            history.push(`/${resource}`);
          });
        } else {
          this.applyTaxToLocCatProd(resourceId);
        }
      } else {
        updateTax(apiToken, requestData, ...resourcePath).then(async (res) => {
          if (res.error) return;
          history.push(`/${resource}`);
        });
      }
    } else {
      addTax(apiToken, requestData, ...resourcePath).then(async (res) => {
        if (res.error) return;
        if (isApply) {
          const newResourceId = res.response[res.response.length - 1].id;
          if (!showCategoriesProducts) {
            updateTax(apiToken, selectedLocations, ...[resource, newResourceId, 'locations']).then(async (res) => {
              if (res.error) return;
              history.push(`/${resource}`);
            });
          } else {
            this.applyTaxToLocCatProd(newResourceId);
          }
        } else {
          history.push(`/${resource}`);
        }
      });
    }
  }

  onBack = () => {
    const { history, match } = this.props;
    const { isApply } = this.state;
    const { resource } = match.params;
    if (isApply) {
      this.setState({
        isApply: false,
      });
    } else {
      history.push(`/${resource}`);
    }
  }

  arrangeProductsByCategory = (products, categories) => {
    if (categories && products) {
      const temp = categories.map((category) => {
        const productsOfCategory = products.filter(product => category.id === product.category.id);
        return { id: category.id, productsOfCategory };
      });
      const result = temp.reduce(
        (obj, item) => Object.assign(obj, { [item.id]: item.productsOfCategory }), {},
      );
      return result;
    }
    return undefined;
  }

  onActionDropdownChange = (event) => {
    const { value } = event.target;
    if (Object.keys(taxActions).includes(value)) {
      this.setState({
        confirmDialogOpen: true,
        selectedAction: value,
      });
    }
  }

  onClickReEnable = () => {
    this.setState({
      confirmDialogOpen: true,
      selectedAction: 'enable',
    });
  }

  onCloseDialog = () => {
    this.setState({ confirmDialogOpen: false });
  }

  onConfirmDialogAction = () => {
    const {
      actions,
      apiToken,
      match,
      history,
    } = this.props;
    const { resource, resourceId } = match.params;
    const { selectedAction } = this.state;
    const resourcePath = [resource, resourceId];
    switch (selectedAction) {
      case 'delete':
        actions.deleteTax(apiToken, resourceId);
        this.onCloseDialog();
        history.push(`/${resource}`);
        break;
      case 'enable':
        actions.updateTax(apiToken, { disabled: false }, ...resourcePath);
        this.onCloseDialog();
        history.push(`/${resource}`);
        break;
      case 'disable':
        actions.updateTax(apiToken, { disabled: true }, ...resourcePath);
        this.onCloseDialog();
        history.push(`/${resource}`);
        break;
      default:
        this.onCloseDialog();
    }
  }

  validateInput = (newValue, field) => {
    const { isRequired } = field;
    const { isRequiredError, invalidDecimalError } = validationErrorMessages.field;
    let errorMsg = '';
    const numberValidations = FieldValidation.validateNumberTypes(newValue, field);
    if (isRequired && !newValue) {
      errorMsg = isRequiredError;
    }
    if (field.key === 'percentage') {
      if (numberValidations.invalidDecimal) {
        errorMsg = `${field.title} ${invalidDecimalError}`;
      }
    }
    return errorMsg;
  }

  handleValueChange = (event, field) => {
    const { taxDetail } = this.state;
    const updatedDetail = cloneDeep(taxDetail);
    const updatedField = updatedDetail[field.key];
    updatedField.value = event.target.value;
    updatedField.isValid = !updatedField.errorMessage;
    updatedField.errorMessage = this.validateInput(event.target.value, field);
    this.setState({
      taxDetail: updatedDetail,
    });
  }

  onDropdown = (id, isLocation) => {
    const { openLocation, openCategory } = this.state;
    const copyOfOpenLocation = [...openLocation];
    const copyOfOpenCategory = [...openCategory];
    if (isLocation) {
      if (openLocation.indexOf(id) === -1) {
        copyOfOpenLocation.push(id);
      } else {
        copyOfOpenLocation.splice(openLocation.indexOf(id), 1);
      }
      this.setState({
        openLocation: copyOfOpenLocation,
      });
    } else {
      if (openCategory.indexOf(id) === -1) {
        copyOfOpenCategory.push(id);
      } else {
        copyOfOpenCategory.splice(openCategory.indexOf(id), 1);
      }
      this.setState({
        openCategory: copyOfOpenCategory,
      });
    }
  }

  renderLocationsOnly = (location) => {
    const { classes } = this.props;
    const isChecked = this.isChecked('locationOnly', location);
    const rootStyle = isChecked
      ? classes.taxLocationsListRootChecked
      : classes.taxLocationsListRoot;
    return (
      <div>
        <List component="nav" classes={{ root: rootStyle }}>
          <ListItem
            key={location.id}
            classes={{ root: classes.taxLocationsListItemRoot }}
          >
            <ListItemText primary={location.name} />
            <Checkbox
              style={commonStyles.itemsHeaderCheckBox}
              onChange={event => this.onCheckDropdown(event, 'locationOnly', false, location)}
              checked={isChecked}
              icon={(
                <Icon style={displayStyles.uncheckedCheckboxIcon}>
                  check_box_outline_blank
                </Icon>
              )}
              checkedIcon={<Icon style={displayStyles.checkedCheckboxIcon}>check_box</Icon>}
            />
          </ListItem>
        </List>
        <Divider />
      </div>
    );
  }

  renderCategoriesDropdown = (category, location = false) => {
    const { classes } = this.props;
    const { openCategory } = this.state;
    const isChecked = !location
      ? this.isChecked('allLocationCategory', null, category)
      : this.isChecked('locationCategory', location, category);
    const rootStyle = isChecked
      ? classes.taxCategoriesListRootChecked
      : classes.taxCategoriesListRoot;
    const isIndeterminate = !location
      ? (this.isIndeterminate('allLocationCategory', null, category) && !isChecked)
      : (this.isIndeterminate('locationCategory', location, category) && !isChecked);
    const collapseOpen = category[0] && openCategory.includes(category[0].category.id);
    return category[0] && (
      <div>
        <Divider />
        <List component="nav" classes={{ root: rootStyle }}>
          <ListItem
            key={category[0].category.id}
            classes={{ root: classes.taxLocationsListItemRoot }}
            button
            onClick={() => this.onDropdown(category[0].category.id, false)}
          >
            <ListItemIcon classes={{ root: classes.taxDropdownArrowIcon }}>
              { collapseOpen ? <ExpandMore /> : <KeyboardArrowRightIcon /> }
            </ListItemIcon>
            <ListItemText primary={category[0].category.name} />
            <ListItemSecondaryAction>
              <Checkbox
                style={styles.taxLocationsCheckbox}
                onChange={event => (!location ? this.onCheckDropdown(event, 'category', true, null, category) : this.onCheckDropdown(event, 'category', false, location, category))}
                checked={isChecked}
                indeterminate={isIndeterminate}
                icon={(
                  <Icon style={displayStyles.uncheckedCheckboxIcon}>
                    check_box_outline_blank
                  </Icon>
                )}
                checkedIcon={<Icon style={displayStyles.checkedCheckboxIcon}>check_box</Icon>}
                indeterminateIcon={(
                  <img
                    src={IndeterminateCheckBox}
                    alt="Indeterminate_Icon"
                  />
                )}
              />
            </ListItemSecondaryAction>
          </ListItem>
          <Collapse in={collapseOpen} timeout="auto" unmountOnExit style={{ minHeight: '100px' }}>
            {
              category.map(product => this.renderProducts(product, location))
            }
          </Collapse>
        </List>
        <Divider />
      </div>
    );
  }

  renderProducts = (product, location) => {
    const { classes } = this.props;
    const isChecked = !location
      ? this.isChecked('allLocationProduct', null, null, product)
      : this.isChecked('locationProduct', location, null, product);
    const rootStyle = isChecked
      ? classes.taxProductsListRootChecked
      : classes.taxProductsListRoot;
    return (
      <div>
        <Divider />
        <List component="nav" classes={{ root: rootStyle }}>
          <ListItem
            key={product.id}
            classes={{ root: classes.taxLocationsListItemProductsRoot }}
          >
            <ListItemText
              primary={product.name}
              classes={{ root: classes.taxProductsTextRoot }}
            />
            <Checkbox
              style={styles.taxLocationsCheckbox}
              onChange={event => (!location ? this.onCheckDropdown(event, 'product', true, null, null, product) : this.onCheckDropdown(event, 'product', false, location, null, product))}
              checked={isChecked}
              icon={(
                <Icon style={displayStyles.uncheckedCheckboxIcon}>
                  check_box_outline_blank
                </Icon>
                  )}
              checkedIcon={<Icon style={displayStyles.checkedCheckboxIcon}>check_box</Icon>}
            />
          </ListItem>
        </List>
      </div>
    );
  }

  renderAllLocationsDropdown = (productsArrangedByCategory) => {
    const { classes } = this.props;
    const arrayOfProductsArrangedByCategory = Object.values(productsArrangedByCategory);
    const { openLocation } = this.state;
    const collapseOpen = openLocation.includes(-1);
    const isChecked = this.isChecked('allLocation');
    const rootStyle = isChecked
      ? classes.taxLocationsListRootChecked
      : classes.taxLocationsListRoot;
    const isIndeterminate = this.isIndeterminate('allLocation', null, null) && !isChecked;
    return (
      <div>
        <List component="nav" classes={{ root: rootStyle }}>
          <ListItem
            classes={{ root: classes.taxLocationsListItemRoot }}
            button
            onClick={() => this.onDropdown(-1, true)}
          >
            <ListItemIcon classes={{ root: classes.taxDropdownArrowIcon }}>
              { collapseOpen ? <ExpandMore /> : <KeyboardArrowRightIcon /> }
            </ListItemIcon>
            <ListItemText primary='All Locations' />
            <ListItemSecondaryAction>
              <Checkbox
                style={styles.taxLocationsCheckbox}
                onChange={event => this.onCheckDropdown(event, 'location', true)}
                checked={isChecked}
                indeterminate={isIndeterminate}
                icon={(
                  <Icon style={displayStyles.uncheckedCheckboxIcon}>
                    check_box_outline_blank
                  </Icon>
                )}
                checkedIcon={<Icon style={displayStyles.checkedCheckboxIcon}>check_box</Icon>}
                indeterminateIcon={(
                  <img
                    src={IndeterminateCheckBox}
                    alt="Indeterminate_Icon"
                  />
                )}
              />
            </ListItemSecondaryAction>
          </ListItem>
          <Collapse in={collapseOpen} timeout="auto" unmountOnExit style={{ minHeight: '100px' }}>
            {
              arrayOfProductsArrangedByCategory
              && arrayOfProductsArrangedByCategory.map(
                category => this.renderCategoriesDropdown(category),
              )
            }
          </Collapse>
        </List>
        <Divider />
      </div>
    );
  }

  renderLocationsDropdown = (location, productsArrangedByCategory) => {
    const { classes } = this.props;
    const arrayOfProductsArrangedByCategory = Object.values(productsArrangedByCategory);
    const { openLocation } = this.state;
    const collapseOpen = openLocation.includes(location.id);
    const isChecked = this.isChecked('location', location);
    const rootStyle = isChecked
      ? classes.taxLocationsListRootChecked
      : classes.taxLocationsListRoot;
    const isIndeterminate = this.isIndeterminate('location', location, null) && !isChecked;
    return (
      <div>
        <List component="nav" classes={{ root: rootStyle }}>
          <ListItem
            key={location.id}
            classes={{ root: classes.taxLocationsListItemRoot }}
            button
            onClick={() => this.onDropdown(location.id, true)}
          >
            <ListItemIcon classes={{ root: classes.taxDropdownArrowIcon }}>
              { collapseOpen ? <ExpandMore /> : <KeyboardArrowRightIcon /> }
            </ListItemIcon>
            <ListItemText primary={location.name} />
            <ListItemSecondaryAction>
              <Checkbox
                style={styles.taxLocationsCheckbox}
                onChange={event => this.onCheckDropdown(event, 'location', false, location)}
                checked={isChecked}
                indeterminate={isIndeterminate}
                icon={(
                  <Icon style={displayStyles.uncheckedCheckboxIcon}>
                    check_box_outline_blank
                  </Icon>
                )}
                checkedIcon={<Icon style={displayStyles.checkedCheckboxIcon}>check_box</Icon>}
                indeterminateIcon={(
                  <img
                    src={IndeterminateCheckBox}
                    alt="Indeterminate_Icon"
                  />
                )}
              />
            </ListItemSecondaryAction>
          </ListItem>
          <Collapse in={collapseOpen} timeout="auto" unmountOnExit style={{ minHeight: '100px' }}>
            {
              arrayOfProductsArrangedByCategory
              && arrayOfProductsArrangedByCategory.map(
                category => this.renderCategoriesDropdown(category, location),
              )
            }
          </Collapse>
        </List>
        <Divider />
      </div>
    );
  }

  render() {
    const {
      taxDetail,
      isApply,
      showCategoriesProducts,
      selectedAction,
      confirmDialogOpen,
    } = this.state;
    const {
      type,
      resources,
      classes,
      loading,
    } = this.props;
    const {
      name,
      percentage,
      disabled,
    } = taxDetail;
    const {
      locations,
      products,
      categories,
    } = resources;
    const isEditTaxes = type === 'edit';
    const productsArrangedByCategory = this.arrangeProductsByCategory(products, categories);
    return (
      <CreateAndEditWrapper
        {...this.props}
        isTaxes
        isEditTaxes={isEditTaxes}
        isApplyTaxes={isApply}
        onClickApplyChanges={this.onClickApplyChanges}
        onBack={this.onBack}
        onActionDropdownChange={this.onActionDropdownChange}
        taxDisabled={disabled.value}
      >
        {
          isApply
            ? (
              <Paper style={commonStyles.paperNoHeightTax}>
                <form noValidate autoComplete="off" style={styles.formContainer}>
                  <Grid
                    container
                    spacing={24}
                    style={{ ...styles.gridContainer }}
                  >
                    <div style={styles.editTaxFieldsContainer}>
                      <div style={styles.infoContainerNoMargin}>
                        <Typography style={styles.taxTitle}>
                          Apply Taxes
                        </Typography>
                        <InfoIcon style={styles.infoIcon} />
                      </div>
                      <div style={styles.infoContainerNoMargin}>
                        <IosSwitch
                          checked={showCategoriesProducts}
                          onChange={this.onSwitchChange}
                          classes={{
                            root: classes.iosSwitchRoot,
                            switchBase: classes.iosSwitchBase,
                          }}
                        />
                        <Typography style={styles.taxSwitchLabel}>
                          Show categories and products for each location.
                        </Typography>
                      </div>
                      <Divider />
                      {
                !showCategoriesProducts
                  && locations
                  && locations.map(location => this.renderLocationsOnly(location))
              }
                      {
                showCategoriesProducts
                && productsArrangedByCategory
                && this.renderAllLocationsDropdown(productsArrangedByCategory)
              }
                      {
                showCategoriesProducts
                && locations
                && productsArrangedByCategory
                && locations.map(
                  location => this.renderLocationsDropdown(location, productsArrangedByCategory),
                )
              }
                    </div>
                  </Grid>
                </form>
              </Paper>
            ) : (
              <Paper style={commonStyles.paperNoHeightTax}>
                <form noValidate autoComplete="off" style={styles.formContainer}>
                  <Grid
                    container
                    spacing={24}
                    style={{ ...styles.gridContainer }}
                  >
                    <div style={styles.editTaxFieldsContainer}>
                      {
                        disabled.value
                          && (
                            <div style={styles.editTaxWarningContainer}>
                              <WarningIcon style={styles.warningIcon} />
                              <Typography style={styles.warningText}>
                                This tax is currently disabled.  It does not apply to any items.
                              </Typography>
                              <Button
                                variant='text'
                                disableRipple
                                disableFocusRipple
                                classes={{
                                  root: classes.reEnableButtonRoot,
                                }}
                                onClick={this.onClickReEnable}
                              >
                                Re-enable
                              </Button>
                            </div>
                          )
                      }
                      <Typography style={styles.taxStepText}>
                        STEP 1 - Required
                      </Typography>
                      <div style={styles.infoContainerNoMargin}>
                        <Typography style={styles.taxTitle}>
                          Tax Details
                        </Typography>
                        <InfoIcon style={styles.infoIcon} />
                      </div>
                      <Typography style={styles.taxSubtitle}>
                        {taxesTextConstants.taxDetailsSubtitle}
                      </Typography>
                      <TextField
                        key={name.key}
                        id={name.key}
                        value={name.value}
                        margin="normal"
                        style={
                          name.errorMessage
                            ? styles.errorTextFieldStyle
                            : styles.textFieldStyle
                        }
                        onChange={() => this.handleValueChange(event, name)}
                        placeholder="Tax Name"
                        inputProps={{
                          ...styles.normalInputPropStyle,
                          maxLength: TAX_NAME_MAX_LENGTH,
                        }}
                        InputProps={{ disableUnderline: true }}
                      />
                      <Typography style={styles.errorMessageStyle}>
                        {name.errorMessage}
                      </Typography>
                      <TextField
                        key={percentage.key}
                        id={percentage.key}
                        value={percentage.value}
                        margin="normal"
                        style={
                    percentage.errorMessage
                      ? styles.errorTextFieldStyle
                      : styles.textFieldStyle
                    }
                        onChange={() => this.handleValueChange(event, percentage)}
                        placeholder="Tax Rate"
                        inputProps={{
                          ...styles.normalInputPropStyle,
                        }}
                        InputProps={{ disableUnderline: true }}
                      />
                      <Typography style={styles.errorMessageStyle}>
                        {percentage.errorMessage}
                      </Typography>
                      <div style={commonStyles.taxDetailsBorder} />
                      <Typography style={styles.taxStepText}>
                        STEP 2 - Required
                      </Typography>
                      <div style={styles.infoContainerNoMargin}>
                        <Typography style={styles.taxTitle}>
                          Apply to Locations, Categories, Products
                        </Typography>
                        <InfoIcon style={styles.infoIcon} />
                      </div>
                      <Typography style={styles.taxSubtitle}>
                        {taxesTextConstants.taxLocationsSubtitle}
                      </Typography>
                      <Button
                        variant="outlined"
                        style={styles.taxLocationsButton}
                        onClick={this.onApplyPage}
                        disabled={loading}
                      >
                        {loading ? 'Loading...' : 'Locations'}
                        <DownChevron
                          style={dropdownStyles.chevron}
                        />
                      </Button>
                    </div>
                  </Grid>
                </form>
              </Paper>
            )
        }
        {
          selectedAction
          && (
            <TaxActionDialog
              onCloseDialog={this.onCloseDialog}
              confirmDialogOpen={confirmDialogOpen}
              taxActionDialogTitle={taxActions[selectedAction].title}
              actionText={taxActions[selectedAction].dialogConfirmText}
              onConfirmDialogAction={this.onConfirmDialogAction}
            />
          )
        }
      </CreateAndEditWrapper>
    );
  }
}

CreateAndEditTax.propTypes = {
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  type: PropTypes.string.isRequired,
  taxes: PropTypes.arrayOf(PropTypes.any),
  loading: PropTypes.bool.isRequired,
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  resources: PropTypes.arrayOf(PropTypes.any),
  taxedLocations: PropTypes.arrayOf(PropTypes.any),
  taxedCategories: PropTypes.arrayOf(PropTypes.any),
  taxedProducts: PropTypes.arrayOf(PropTypes.any),
  classes: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
};

CreateAndEditTax.defaultProps = {
  taxes: null,
  resources: null,
  taxedLocations: null,
  taxedCategories: null,
  taxedProducts: null,
};

export default connect(
  state => ({
    loading: state.get('loading').toJS().loading,
    taxes: state.get('taxes').toJS().taxList,
    taxedLocations: state.get('taxes').toJS().taxedLocations,
    taxedProducts: state.get('taxes').toJS().taxedProducts,
    taxedCategories: state.get('taxes').toJS().taxedCategories,
  }),
)(withStyles(resourceFormStyle)(CreateAndEditTax));
